<template>
  <v-container fluid>
    <div id="app ">
      <div style="display: flex; justify-content: space-between;">
        <!-- <v-col cols="11"> -->
        <Breadcrumb
          class="row justify-content-center mt-4"
          :crumbs="crumbs"
          @selected="selected"
        />
        <!-- </v-col> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <newFiltercomp
          style="margin-right: 5px !important"
          :filter_data="param"
        />
      </v-col>
    </v-row>
    <v-row>
      <div v-bind:key="val.id" v-for="val in insightsData">
        <v-row>
          <v-col v-if="showInsights">
            <v-container>
              <v-card
                id="ins1"
                class="oee-card oee-card-white card-shadow "
                height="213px"
                width="350px"
                style="overflow-y: auto; "
              >
                <v-card-text>
                  <v-row align="center">
                    <v-icon color="primary">icon-insights</v-icon>
                    <v-card-title class="pt-0 pb-0">
                      Process Insights</v-card-title
                    >
                  </v-row>
                  <v-row align="center">
                    <div v-bind:key="epa.id" v-for="epa in val.insights">
                      <span>
                        <p>
                          <span class="insights_param"
                            >{{ epa.parameter_name }}
                          </span>
                          <span
                            v-if="'insight_type' in epa"
                            v-bind:class="{
                              insights_normal:
                                epa.insight_type == '0' ||
                                epa.insight_type == 'normal',
                              insights_alert: epa.insight_type == 'alert',
                              insights_caution: epa.insight_type == 'caution',
                            }"
                          >
                            <span>
                              {{ epa.insight_statement }}
                            </span>
                          </span>
                        </p>
                      </span>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-card
                id="ins2"
                class="oee-card oee-card-white card-shadow "
                height="213px"
                width="505px"
                style="overflow-y: auto; "
              >
                <v-card-text>
                  <v-row align="center">
                    <v-icon color="primary">icon-insights</v-icon>
                    <v-card-title class="pt-0 pb-0">
                      Process Insights</v-card-title
                    >
                  </v-row>
                  <v-row>
                    <div v-bind:key="epa.id" v-for="epa in val.insights">
                      <pre>
-----------------------------------------------
  </pre
                      >
                      <p>
                        <span
                          v-if="'insight_type' in epa"
                          class="insights_param"
                        >
                          {{ epa.parameter_name }}
                        </span>
                        <span
                          v-if="'insight_type' in epa || 'insight_type' in epa"
                          v-bind:class="{
                            insights_normal:
                              epa.insight_type == '0' ||
                              epa.insight_type == 'normal',
                            insights_alert: epa.insight_type == 'alert',
                            insights_caution: epa.insight_type == 'caution',
                          }"
                          v-html="epa.insight_statement"
                        >
                          {{ epa.insight_statement }}
                        </span>
                      </p>
                    </div>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </div>
      <v-row class="mb-3 mt-3 mx-auto">
        <div style="display: flex">
          <div
            v-bind:key="gag.id"
            v-for="gag in widgets_obj_map.get('Digital Gauge')"
            class="gauge"
          >
            <guage v-bind:gag="gag" />
          </div>
          <div
            v-bind:key="gag.id"
            v-for="gag in widgets_obj_map.get('Thermometer')"
            class="gauge"
          >
            <thermometer v-bind:thermoProp="gag" />
          </div>
          <div
            v-bind:key="gag.id"
            v-for="gag in widgets_obj_map.get('Cylinder')"
            class="gauge"
          >
            <progressComponent v-bind:cardProps="gag" />
          </div>
          <div
            v-bind:key="gag.id"
            v-for="gag in widgets_obj_map.get('Battery')"
            class="gauge"
          >
            <progressComponent v-bind:cardProps="gag" />
          </div>
        </div>
      </v-row>
    </v-row>
    <v-row>
      <div v-bind:key="apq.id" v-for="apq in apqData">
        <v-row>
          <v-col>
            <v-container>
              <v-card
                class="oee-card oee-card-white card-shadow"
                height="280px"
                width="505px"
              >
                <v-row align="center" class="mb-2 ">
                  <v-icon
                    color="primary"
                    class="pt-3 pl-3 pb-3"
                    style="margin-bottom:-30px"
                    >{{ Changeiconaspertitle(apq.chartTitle) }}</v-icon
                  >
                  <v-card-title
                    class=" pt-3 pl-3 pb-3"
                    style="margin-bottom:-30px"
                    >{{ apq.chartTitle }}</v-card-title
                  >
                </v-row>
                <v-row align="center" class="text-center mbN-4">
                  <v-col cols="12" sm="12" md="12" class="pr-4 pl-3 pa-1 pb-3">
                    <div id="div2">
                      <apexchart
                        type="line"
                        height="250px"
                        width="320px"
                        :options="apq.chartOptions"
                        :series="apq.series"
                      ></apexchart>
                    </div>
                    <div id="div1">
                      <apexchart
                        type="line"
                        height="250px"
                        width="475px"
                        :options="apq.chartOptions"
                        :series="apq.series"
                      ></apexchart>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import guage from "../components/guage";
import thermometer from "../components/temperatureComp";

import axios from "axios";
import newFiltercomp from "../components/newFiltercomp.vue";
import constants from "../constants";
import router from "../router";
import progressComponent from "../components/ProgressComponent.vue";

var prevNowPlaying = null;

export default {
  components: {
    guage,
    thermometer,
    newFiltercomp,
    Breadcrumb,
    LoaderProgress,
    progressComponent,
  },
  data: () => ({
    crumbs: ["Home", "DM Trends"],
    present: false,
    showLoader: false,
    macId: 0,
    guageSet: [],
    apqData: [],
    insightsData: [],
    apqData_i: [],
    machine_id_Selected: "",
    start_date: "",
    end_date: "",
    checkbox: false,
    oilInterval: "",
    showInsights: false,
    parameter_group_obj: [],
    minlist: [],
    maxlist: [],
    widgets_obj_map: new Map(),
    alert_caution_map: new Map(),
    param: {
      machine: true,
      time_period: false,
      check: false,
      aggfunc: true,
      date: false,
      date_2: false,
      time: false,
      time2: false,
      select_1: 1,
      machineDropDownLabel: "Select Chamber/Silos",
    },
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,

    // progressOptions : {
    //   maxwidth : '200px',
    //   maxheight : '120px',
    //   value :25,
    //   barType : "battery", //battery, line, circle, cylinder
    //   barWidth : 150,
    //   barHeight : 40,
    //   component_name : "Battery"
    // },
  }),
  mounted() {
    this.machine_id_Selected = this.$route.params.macId;
  },
  beforeDestroy() {
    console.log("beforeDestroy enerrgy parameter analysis page");
    clearInterval(this.oilInterval);
    this.checkbox = false;
  },
  methods: {
    Changeiconaspertitle(value) {
      if (value == "ISO Rating") return "mdi-seal";
      else if (value == "RH Data") return "icon-bolt";
      else if (value == "NAS") return "icon-bolt";
    },
    selected(crumb) {
      if (crumb === "Home") {
        // console.log("checking session object",sessionStorage.getItem("route_first_option"));
        if (
          `/${sessionStorage.getItem("route_first_option")}` ==
          "/DairyMonitoring"
        ) {
          // console.log(
          // "Checking duplicate and proved ",
          // `/${sessionStorage.getItem("route_first_option")}`
          // );
        } else {
          router.push(`/${sessionStorage.getItem("route_first_option")}`);
        }
      }

      // console.log(crumb);
    },
    moveToEnergyMonitoring() {
      this.$router.push({
        name: "EnergyMonitoringTrends",
        params: { macId: this.machine_id_Selected },
      });
    },
    formatDateData: (x) => {
      var today = new Date();
      today.setDate(today.getDate() - x);
      return (today / 1000).toFixed(0);
    },
    formatDate: (y) => {
      var today = new Date(y);
      return (today / 1000).toFixed(0);
    },

    getEnergyData: function(machine_id, startDate, endDate, show, grp_show) {
      let params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getDPMAnalysisData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      axios(config).then((response) => {
        try {
          // console.log("actual data is ", response.data);
          let gaugeData = response.data.data[0].data || [];

          if (this.widgets_obj_map.has("Digital Gauge")) {
            let dataObj = this.widgets_obj_map.get("Digital Gauge");
            for (let i = 0; i < dataObj.length; i++) {
              let singleGaugeComponent = dataObj[i];
              for (let j = 0; j < gaugeData.length; j++) {
                let eachDataObj = gaugeData[j];
                if (eachDataObj.parameter_name == singleGaugeComponent.id) {
                  singleGaugeComponent.originalValue = eachDataObj.value; //+ String.fromCodePoint(8451);
                  let compareValue =
                    (eachDataObj.value * 100) / singleGaugeComponent.maxValue;
                  singleGaugeComponent.series = [compareValue];
                  const milliseconds = eachDataObj.unix_ts;
                  const dateObject = new Date(milliseconds);
                  const humanDateFormat = dateObject.toLocaleString();
                  singleGaugeComponent.timestamp = humanDateFormat;
                }
              }
            }
          }

          if (this.widgets_obj_map.has("Thermometer")) {
            console.log("");
            let dataObj = this.widgets_obj_map.get("Thermometer");
            for (let i = 0; i < dataObj.length; i++) {
              let singleGaugeComponent = dataObj[i];
              for (let j = 0; j < gaugeData.length; j++) {
                let eachDataObj = gaugeData[j];
                if (eachDataObj.parameter_name == singleGaugeComponent.id) {
                  singleGaugeComponent.originalValue = eachDataObj.value; //+ String.fromCodePoint(8451);
                  // let compareValue =
                  //   (eachDataObj.value * 100) / singleGaugeComponent.maxValue;
                  singleGaugeComponent.series = eachDataObj.value;

                  const milliseconds = eachDataObj.unix_ts;
                  const dateObject = new Date(milliseconds);
                  const humanDateFormat = dateObject.toLocaleString();
                  singleGaugeComponent.timestamp = humanDateFormat;
                }
              }
            }
          }
          if (this.widgets_obj_map.has("Battery")) {
            let dataObj = this.widgets_obj_map.get("Battery");
            for (let i = 0; i < dataObj.length; i++) {
              let singleGaugeComponent = dataObj[i];
              for (let j = 0; j < gaugeData.length; j++) {
                let eachDataObj = gaugeData[j];
                if (eachDataObj.parameter_name == singleGaugeComponent.id) {
                  // console.log("checking value for battery",singleGaugeComponent);
                  singleGaugeComponent.originalValue = eachDataObj.value;
                  // singleGaugeComponent.hideBarText = true;
                  const milliseconds = eachDataObj.unix_ts;
                  const dateObject = new Date(milliseconds);
                  const humanDateFormat = dateObject.toLocaleString();
                  singleGaugeComponent.timestamp = humanDateFormat;
                }
              }
            }
          }
          if (this.widgets_obj_map.has("Cylinder")) {
            let dataObj = this.widgets_obj_map.get("Cylinder");
            for (let i = 0; i < dataObj.length; i++) {
              let singleGaugeComponent = dataObj[i];
              for (let j = 0; j < gaugeData.length; j++) {
                let eachDataObj = gaugeData[j];
                if (eachDataObj.parameter_name == singleGaugeComponent.id) {
                  singleGaugeComponent.originalValue = eachDataObj.value;
                  const milliseconds = eachDataObj.unix_ts;
                  const dateObject = new Date(milliseconds);
                  const humanDateFormat = dateObject.toLocaleString();
                  singleGaugeComponent.timestamp = humanDateFormat;
                }
              }
            }
          }
          // let actualData = response.data.data[0].analysis || {};
          for (let i = 0; i < this.apqData.length; i++) {
            let eachChartObj = this.apqData[i];
            // if (Object.keys(actualData).length > 0) {
            //   eachChartObj.chartOptions = {
            //     ...eachChartObj.chartOptions,
            //     ...{
            //       xaxis: {
            //         categories: actualData["unix_ts"],
            //       },
            //     },
            //   };
            // }
            let seriesvalues = [];
            for (
              let param_grp_index = 0;
              param_grp_index < this.parameter_group_obj.length;
              param_grp_index++
            ) {
              if (
                this.parameter_group_obj[param_grp_index]["group"] ==
                eachChartObj.id
              ) {
                let each_param_group_list = this.parameter_group_obj[
                  param_grp_index
                ]["parameter_list"];
                for (
                  let param_list_index = 0;
                  param_list_index < each_param_group_list.length;
                  param_list_index++
                ) {
                  {
                    let grp_device_id =
                      each_param_group_list[param_list_index]["device_id"] ||
                      -1;
                    let actualData = response.data.data[0][grp_device_id] || {};

                    if (Object.keys(actualData).length > 0) {
                      eachChartObj.chartOptions = {
                        ...eachChartObj.chartOptions,
                        ...{
                          xaxis: {
                            categories: actualData["unix_ts"],
                          },
                        },
                      };
                    }

                    // let seriesvalues = eachChartObj.series;

                    // seriesvalues.forEach((param) => {
                    //   if (param.name != "Alert" && param.name != "Caution") {
                    //     response.data.data[0][]
                    //   }
                    // });
                    let singlValue = {
                      name:
                        each_param_group_list[param_list_index]["actual_name"],
                      data:
                        actualData[
                          each_param_group_list[param_list_index]["id"]
                        ],
                    };
                    seriesvalues.push(singlValue);
                    // console.log("assigning values for id ",each_param_group_list[param_list_index]["id"]);
                  }
                }
              }
            }
            let alert_caution_list = this.alert_caution_map.get(
              eachChartObj.id
            );
            for (
              let seriesListindex = 0;
              seriesListindex < alert_caution_list.length;
              seriesListindex++
            ) {
              let each_list = alert_caution_list[seriesListindex];
              for (let index = 0; index < each_list.length; index++) {
                let obj = each_list[index];
                obj.data = [];
                seriesvalues.push(obj);
              }
            }
            eachChartObj.series = seriesvalues;
          }
          this.showLoader = false;
        } catch (exception) {
          this.apqData = [];
          this.guageSet = [];
          this.present = true;
          this.showLoader = false;
          console.log("error", exception);
        }
      });
    },

    searchNew: function(machine_id, startDate, endDate, show, grp_show, check) {
      // this.insightsData = [];
      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;
      let params = "";
      this.showLoader = true;
      console.log("default value", this.start_date);
      if (this.start_date == "") {
        params = `?machine=${machine_id}`;
      } else {
        params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }

      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getDPMAnalysis${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          // if (response.data.data != []) {
          //   this.showInsights = false;
          // }
          try {
            this.showInsights = false;
            this.widgets_obj_map.clear();
            // console.log("checking data", response.data.data[0]);
            let data = response.data.data[0];
            let condemn_list =
              response.data.data[0].condemning_limit_list || [];
            let parameter_group = data.parameter_group;
            this.parameter_group_obj = data.parameter_group;
            data = response.data.data[0].data || [];

            for (
              let param_grp_index = 0;
              param_grp_index < parameter_group.length;
              param_grp_index++
            ) {
              let id = -1;
              let minList = [];
              let maxList = [];
              let chartMinMaxObj = {};
              let dbc_params_map = new Map();
              let each_param_group_list =
                parameter_group[param_grp_index]["parameter_list"];
              let group_name = parameter_group[param_grp_index]["group"];
              let widget_type_name =
                parameter_group[param_grp_index]["widget_name"];

              console.log("checking param list group_name", group_name);
              if (!this.widgets_obj_map.has(widget_type_name)) {
                this.widgets_obj_map.set(widget_type_name, []);
              }
              const widgets_list = this.widgets_obj_map.get(widget_type_name);

              let chart_data_list = [];

              for (
                let param_grp_list_index = 0;
                param_grp_list_index < each_param_group_list.length;
                param_grp_list_index++
              ) {
                let param_actual_name =
                  each_param_group_list[param_grp_list_index]["actual_name"];
                let component_name =
                  each_param_group_list[param_grp_list_index]["name"];
                var maxValue = "";
                var minValue = "";
                id = each_param_group_list[param_grp_list_index]["id"];
                // let device_id = each_param_group_list[param_grp_list_index]["device_id"] || -1;
                console.log(" param_actual_name is ", param_actual_name);
                console.log(" param_display_name is ", component_name);
                var timestamp = "";
                let originalValue = 0;
                let text_color = "";
                let fontSize = 0;
                let textAdjustmentY = 0;
                let textfontFamily = "Arial"; //done till this
                // let textEnabled = true;
                let textmarginLeft = "1px";
                let fontWeight = "bold";
                let widget_foreground_color = "#1589FF";
                let widget_background_color = "";
                let widget_border_color = "";
                let ticks = 6;
                let ticksEnabled = true;
                let tickColor = "black";
                let tickWidth = "1";
                let widget_height = 0;
                let widget_width = 0;
                let card_maxwidth = "";
                let card_maxheight = "";
                let widget_type = "";
                let series_type = "";
                let yaxis_title = "";
                let display_opposite = "";
                let yaxis_scale_display = "";
                let yaxis_scale_series_name = "";
                let hide_widget_text = false;
                let rotate_widget = false;

                if (
                  each_param_group_list[param_grp_list_index]["db_parameters"]
                ) {
                  let each_parameter =
                    each_param_group_list[param_grp_list_index][
                      "db_parameters"
                    ];

                  card_maxwidth = each_parameter.card_max_width || "170px";
                  card_maxheight = each_parameter.card_max_height || "170px";
                  widget_width = each_parameter.widget_width || 20;
                  widget_height = each_parameter.widget_height || 50;
                  maxValue = each_parameter.max_value;
                  minValue = each_parameter.min_value;
                  widget_type = each_parameter.widget_type || "line"; //battery, line, circle, cylinder
                  series_type = each_parameter.series_type || "line";
                  yaxis_title = each_parameter.yaxis_title;
                  display_opposite = each_parameter.display_opposite;
                  yaxis_scale_display = each_parameter.yaxis_scale_display;
                  yaxis_scale_series_name =
                    each_parameter.yaxis_scale_series_name;
                  hide_widget_text = each_parameter.hide_widget_text || true;
                  widget_background_color =
                    each_parameter.widget_background_color;
                  rotate_widget = each_parameter.rotate_widget;

                  widget_foreground_color =
                    each_parameter.widget_foreground_color;
                  display_opposite = each_parameter.display_opposite;
                  display_opposite = each_parameter.display_opposite;
                  display_opposite = each_parameter.display_opposite;
                  ticksEnabled = each_parameter.ticksEnabled || true;
                  tickWidth = each_parameter.tickWidth || "1";
                  tickColor = each_parameter.tickColor || "black";
                  ticks = each_parameter.ticks || 6;
                  widget_border_color = each_parameter.widget_border_color;

                  fontWeight = each_parameter.fontWeight;
                  textmarginLeft = each_parameter.textmarginLeft;
                  // textEnabled =each_parameter.textEnabled;
                  text_color = each_parameter.text_color;
                  fontSize = each_parameter.fontSize;
                  textAdjustmentY = each_parameter.textAdjustmentY;
                  textfontFamily = each_parameter.textfontFamily;

                  maxList.push(maxValue);
                  minList.push(minValue);
                  dbc_params_map.set(
                    param_actual_name,
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                  );
                }

                console.log("checking min and max", minValue, maxValue);
                let series = [0];
                // let width = "100%";
                // let height = "70%";
                // let maxwidth = "170px";
                // let maxheight = "170px";
                // let style='margin-left:50px;margin-top:-20px; margin-bottom: -15px;'

                if (
                  widget_type_name == "Digital Gauge" ||
                  widget_type_name == "Battery" ||
                  widget_type_name == "Cylinder" ||
                  widget_type_name == "Thermometer"
                ) {
                  // minValue = minValue +'&#8451;';
                  //                 maxheight =

                  let singleComponent = {
                    id,
                    originalValue,
                    component_name,
                    card_maxwidth,
                    card_maxheight,
                    widget_width,
                    widget_height,
                    series,
                    timestamp,
                    minValue,
                    maxValue,
                    widget_type,
                    series_type,
                    yaxis_title,
                    display_opposite,
                    yaxis_scale_display,
                    yaxis_scale_series_name,
                    hide_widget_text,
                    rotate_widget,
                    param_actual_name,
                    widget_background_color,
                    widget_foreground_color,
                    ticksEnabled,
                    tickWidth,
                    tickColor,
                    ticks,
                    widget_border_color,
                    fontWeight,
                    textmarginLeft,
                    text_color,
                    fontSize,
                    textAdjustmentY,
                    textfontFamily,
                  };
                  widgets_list.push(singleComponent);
                }

                // else if (widget_type_name == "Thermometer") {
                //   // minValue = minValue +'&#8451;';

                //   let singleComponent = {
                //     id,
                //     originalValue,
                //     component_name,
                //     card_maxwidth,
                //     card_maxheight,
                //     series,
                //     width,
                //     timestamp,
                //     minValue,
                //     maxValue,
                //     height,
                //     fontSize,
                //     text_color,
                //     textAdjustmentY,
                //     textfontFamily,
                //     textEnabled,
                //     textmarginLeft,
                //     fontWeight,
                //     widget_border_color,
                //     ticks,
                //     ticksEnabled,
                //     tickColor,
                //     tickWidth,
                //     layoutheight,
                //     layoutwidth,
                //     widget_type

                //   };
                //   widgets_list.push(singleComponent);
                // }
                //  else if (
                //   widget_type_name == "Battery" ||
                //   widget_type_name == "Cylinder"
                // ) {
                //  let barFGColor = "";
                //   if (
                //     each_param_group_list[param_grp_list_index]["db_parameters"]
                //   ) {
                //     barFGColor =
                //       each_param_group_list[param_grp_list_index][
                //         "db_parameters"
                //       ].barFGColor || "#008FFB";

                //   }
                //   originalValue = 0;
                //   let singleComponent = {
                //     id,
                //     originalValue,
                //     component_name,
                //     widget_type,
                //     timestamp,
                //     barFGColor,
                //     hideBarText,
                //     rotate_widget,
                //   };
                //   console.log("single compo is ", singleComponent);
                //   widgets_list.push(singleComponent);
                // }
                else if (widget_type_name == "Line Chart") {
                  let singlValue = {
                    name: param_actual_name,
                    // device: device_id,
                    data: [],
                  };
                  chart_data_list.push(singlValue);
                }
              }
              chartMinMaxObj = {
                minvalue: Math.min(...minList),
                maxvalue: Math.max(...maxList),
              };

              if (widget_type_name == "Line Chart") {
                let finalData = this.finalizeDataNew(
                  chart_data_list,
                  group_name,
                  condemn_list,
                  chartMinMaxObj,
                  dbc_params_map
                );

                widgets_list.push(finalData[0]);
                this.alert_caution_map.set(group_name, finalData[1]);
              }
            }

            if (this.widgets_obj_map.has("Digital Gauge")) {
              this.guageSet = this.widgets_obj_map.get("Digital Gauge");
            }
            if (this.widgets_obj_map.has("Thermometer")) {
              this.guageSet = this.widgets_obj_map.get("Thermometer");
            }
            if (this.widgets_obj_map.has("Line Chart")) {
              this.apqData = this.widgets_obj_map.get("Line Chart");
            }
            this.showInsights = true;
            let machineinsights = response.data.data[0].machine_insights || [];

            this.present = false;
            // console.log("checking machine insights", machineinsights);
            this.insightsData = [{ id: 1, insights: machineinsights }] || [];

            this.getEnergyData(
              this.machine_id_Selected,
              startDate,
              endDate,
              show,
              grp_show,
              check
            );
          } catch (exception) {
            this.apqData = [];
            this.guageSet = [];
            this.present = true;
            this.showLoader = false;
            console.log("error", exception);
          }
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    finalizeDataNew: (
      seriesvalues,
      chartname,
      condemn_list,
      chartMinMaxObj,
      dbc_params_map
    ) => {
      console.log(
        "checking seriesvalues=>",
        seriesvalues,
        "chart names=>",
        chartname,
        "condemn_list =>",
        condemn_list,
        "dbc_params_map",
        dbc_params_map
      );
      console.log("chartMinMaxObj ist", chartMinMaxObj);
      let checkin = "";
      let lowAlertlist = [];
      let highAlertlist = [];
      let lowCautionlist = [];
      let highCautionlist = [];

      for (let i = 0; i < condemn_list.length; i++) {
        if (condemn_list[i].group_name == chartname) {
          checkin = condemn_list[i];
          if (checkin.high_alert != "null") {
            highAlertlist.push(checkin.high_alert);
          }
          if (checkin.low_alert != "null") {
            lowAlertlist.push(checkin.low_alert);
          }
          if (checkin.high_caution != "null") {
            highCautionlist.push(checkin.high_caution);
          }
          if (checkin.low_caution != "null") {
            lowCautionlist.push(checkin.low_caution);
          }
        }
      }
      let lowAlertValue = Math.min(...lowAlertlist);
      let highAlertValue = Math.max(...highAlertlist);
      let lowCautionValue = Math.min(...lowCautionlist);
      let highCautionValue = Math.max(...highCautionlist);

      // console.log("lowCautionValue confirm", lowCautionValue);
      // console.log("highAlertValue confirm", highAlertValue);
      let lowAlertChart = {
        name: "Alert",
        data: [lowAlertValue],
      };
      let lowCautionChart = {
        name: "Caution",
        data: [lowCautionValue],
      };
      let highAlertChart = {
        name: "Alert",
        data: [highAlertValue],
      };
      let highCautionChart = {
        name: "Caution",
        data: [highCautionValue],
      };
      let alertsValues = [];
      let cautionsValues = [];

      // console.log("cehcking alerts", checkin.low_alert, checkin.high_alert);
      if (isFinite(lowAlertValue)) {
        alertsValues.push(lowAlertChart);
      }
      if (isFinite(highAlertValue)) {
        alertsValues.push(highAlertChart);
      }

      if (isFinite(lowCautionValue)) {
        cautionsValues.push(lowCautionChart);
      }
      if (isFinite(highCautionValue)) {
        cautionsValues.push(highCautionChart);
      }

      console.log("checking alerts array", highAlertChart, alertsValues);

      seriesvalues = seriesvalues.concat(alertsValues);
      seriesvalues = seriesvalues.concat(cautionsValues);
      // console.log("checking seriveValuies", seriesvalues);
      let alert_caution_list = [alertsValues, cautionsValues];

      let getColors = (seriesvalues) => {
        let colors = [];
        let joiningColors = [];

        let count = seriesvalues.length;
        colors = constants.colors.slice(0, count);
        // console.log("checking colors", colors);
        seriesvalues.forEach((param) => {
          if (param.name == "Alert") {
            joiningColors.push(constants.exxonRed);
          } else if (param.name == "Caution") {
            joiningColors.push(constants.darkOrange);
          } else {
            joiningColors.push(colors.shift());
          }
        });
        // console.log("joiningColors ", joiningColors);

        return joiningColors;
      };
      let getAnnotationData = (value) => {
        let originalValue = value;
        // console.log("checking annotation values", value);
        if (value == "null") {
          value = -Infinity;
        } else {
          value = originalValue;
        }
        return value;
      };

      let getYAxisProperties = (seriesvalues) => {
        let yaxisArray = [];
        let multi_yaxis_display_array = [];
        // console.log("checking values for data=>", seriesvalues);
        // console.log("chartMinMaxObj is =>", chartMinMaxObj);
        // console.log("dbc_params_map here is ", dbc_params_map);
        // let count = 0;
        seriesvalues.forEach((param) => {
          if (param.name == "Alert" || param.name == "Caution") {
            return;
          }
          console.log("checking param.name=>", param.name);
          let dbc_parameters_obj = {};
          if (dbc_params_map) {
            dbc_parameters_obj = dbc_params_map.get(param.name);
            console.log("dbc_parameters_obj=>", dbc_parameters_obj);
          }

          let usual = {};
          let yaxis_title = "";
          if (
            dbc_parameters_obj != undefined &&
            "yaxis_title" in dbc_parameters_obj
          ) {
            yaxis_title = dbc_parameters_obj["yaxis_title"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "series_type" in dbc_parameters_obj
          ) {
            param.type = dbc_parameters_obj["series_type"];
          }
          usual.title = {
            text: yaxis_title,
          };
          if (
            dbc_parameters_obj != undefined &&
            "yaxis_decimals" in dbc_parameters_obj
          ) {
            usual.decimalsInFloat = dbc_parameters_obj["yaxis_decimals"];
          } else {
            usual.decimalsInFloat = 0;
          }

          if (
            dbc_parameters_obj != undefined &&
            "max_value" in dbc_parameters_obj
          ) {
            usual.max = dbc_parameters_obj["max_value"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "min_value" in dbc_parameters_obj
          ) {
            usual.min = dbc_parameters_obj["min_value"];
          }

          if (
            dbc_parameters_obj != undefined &&
            "yaxis_force_nice_scale" in dbc_parameters_obj
          ) {
            usual.forceNiceScale = dbc_parameters_obj["yaxis_force_nice_scale"];
            if (dbc_parameters_obj["yaxis_force_nice_scale"] == false) {
              if ("yaxis_tick_amount" in dbc_parameters_obj) {
                usual.tickAmount = dbc_parameters_obj["yaxis_tick_amount"];
              }
            }
          } else {
            usual.forceNiceScale = true;
          }

          if (
            dbc_parameters_obj != undefined &&
            "yaxis_scale_series_name" in dbc_parameters_obj
          ) {
            usual.seriesName = dbc_parameters_obj["yaxis_scale_series_name"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "yaxis_scale_display" in dbc_parameters_obj
          ) {
            usual.show = dbc_parameters_obj["yaxis_scale_display"];
          }
          if (
            dbc_parameters_obj != undefined &&
            "display_opposite" in dbc_parameters_obj
          ) {
            usual.opposite = dbc_parameters_obj["display_opposite"];
          }

          usual.showAlways = true;

          if (usual.show == true) {
            yaxisArray.push(usual);
          }

          {
            multi_yaxis_display_array.push(usual);
            // count += 1;
            // console.log(count);
          }
        });

        // console.log("yaxis array is ", yaxisArray);
        if (yaxisArray.length == 1) {
          return yaxisArray;
        } else {
          return multi_yaxis_display_array;
        }
      };
      let timestampsLt = [];
      let chartData = {
        id: chartname,
        chartTitle: chartname,
        chartOptions: {
          colors: getColors(seriesvalues),

          chart: {
            animations: {
              enabled: false,
            },
            height: "230px",
            type: "line",
            zoom: {
              type: "x",
              enabled: true,
              autoScaleYaxis: false,
            },
            toolbar: {},
          },
          annotations: {
            yaxis: [
              {
                y: getAnnotationData(highAlertValue) || -Infinity,
                borderColor: "#ff0000",
                borderWidth: 3,
                label: {
                  borderColor: "#cc0066",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#cc0066",
                  },
                },
              },
              {
                y: getAnnotationData(highCautionValue) || -Infinity,
                borderColor: "#FFA500",
                borderWidth: 3,
                label: {
                  borderColor: "#A52A2A",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#cc0066",
                  },
                },
              },
              {
                y: getAnnotationData(lowAlertValue) || -Infinity,
                borderColor: "#ff0000",
                borderWidth: 3,
                label: {
                  borderColor: "#996633",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#996633",
                  },
                },
              },
              {
                y: getAnnotationData(lowCautionValue) || -Infinity,
                borderColor: "#FFA500",
                borderWidth: 3,
                label: {
                  borderColor: "#996633",
                  style: {
                    color: "#fff",
                    width: 2,
                    background: "#996633",
                  },
                },
              },
            ],
          },

          legend: {
            position: "bottom",
            horizontalAlign: "center",
            showForSingleSeries: true,

            style: {},
          },

          xaxis: {
            title: {
              text: "Time",
              align: "right",
              style: {
                color: "#484848",
                fontSize: "14px",
                fontWeight: "bold",
              },
            },
            type: "datetime",
            categories: timestampsLt,
            datetimeUTC: false,
            labels: {
              datetimeUTC: false,
            },
            axisBorder: {
              show: true,
              color: "#78909C",
              height: 1,
              width: "100%",
              offsetX: 0,
              offsetY: 0,
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          yaxis: getYAxisProperties(seriesvalues),
          stroke: {
            width: [2, 2, 2],
            curve: "straight",
          },
          tooltip: {
            shared: true,
            intersect: false,
            x: {
              format: "dd MMM - HH : mm: ss",
            },
          },
        },
        series: seriesvalues,
        markers: {
          size: 0,
        },
      };
      // console.log("after creating chart data", chartData);
      return [chartData, alert_caution_list];
    },
    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      let count = 0;

      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );

      if (check === true) {
        if (prevNowPlaying) {
          clearInterval(prevNowPlaying);
        }
        prevNowPlaying = setInterval(() => {
          let unix = Math.round(+new Date() / 1000);
          this.end_date = unix;

          this.searchNew(
            this.machine_id_Selected,
            this.start_date,
            this.end_date,
            show,
            grp_show
          );
          count += 1;
          console.log("checking count ", count, "timestamp", new Date());
        }, 30000);
      }
    },
  },
};
</script>
<style scoped>
@media screen and (min-width: 600px) {
  #div2 {
    display: none;
  }
  #ins1 {
    display: none;
  }
}

/* On screens that are 600px wide or less, the background color is olive */
@media screen and (max-width: 600px) {
  #div1 {
    display: none;
  }
  #ins2 {
    display: none;
  }
}
.v-list-item--link {
  border-bottom: 1px solid #e1e1e1;
}

.row.bg-white.mydrop {
  padding: 13px;
}
.my-datelist2.v-list {
  border-top: 1px solid #e1e1e1 !important;
}

.my-datelist2 .v-list-item__title {
  align-self: center;
  font-size: 0.91rem;
  color: #7e84a3;
}

.my-datelist2 .v-list-item {
  min-height: 34px;
}
.my-datelist2 .v-list-item:hover {
  background-color: #e9e9e9;
}

.my-datelist2 .v-list-item:hover .v-list-item__title {
  color: #0c479d;
}

.my-datelist2.v-sheet.v-list {
  padding: 0;
  /* margin-top: -35px; */
}

.btn-square2 {
  height: 48px !important;
  min-width: 48px !important;
  padding: 0 !important;
  border-radius: 5px !important;
}
.insights_ideal {
  color: #484848;
  font-size: 14px;
  font-weight: bold;
}
.insights_alert {
  color: #fe000c;
  font-size: 14px;
  font-weight: bold;
}
.insights_caution {
  color: #ffff00;
  font-size: 14px;
  font-weight: bold;
}
.insights_normal {
  color: #228517a4;
  font-size: 14px;
  font-weight: bold;
}
.insights_param {
  color: #484848;
  font-size: 16px;
  font-weight: bold;
}
</style>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
